import { getUserInfoByToken, loginRequest } from '@/api/modules/rbac';
import axios from '@/libs/api.request';

export const login = ({ userName, password }) => {
    const data = {
        'userName': userName,
        'password': password
    };
    return loginRequest(data);
};

export const getUserInfo = token => {
    const data = {
        'token': token
    };
    return getUserInfoByToken(data);
};

export const resetPassword = data => {
    return axios.request({
        url: 'api/user/resetPassword',
        data: data,
        method: 'post'
    });
};

export const helpResetPassword = data => {
    return axios.request({
        url: 'api/user/helpResetPassword',
        data: data,
        method: 'post'
    });
};
